/**
 * @module store/marathons/getters
 *
 * @version 1.0.0
 * @copyright SBC 2019
 */


/**
 * Getter: Возвращает массив стартов (текущую "страницу")
 *
 * @returns {array}
 */
const challenges = state => state.challenges;


/**
 * Getter: Возвращает общее число стартов
 *
 * @returns {number}
 */
const challengesCount = state => state.total;


/**
 * Getter: Возвращает флаг, загружаются ли в текущий момент страница со стартами
 *
 * @returns {boolean}
 */
const isChallengesLoading = state => state.isLoading;


export default {
  challenges,
  challengesCount,
  isChallengesLoading,
};
